import { Database, Server, HardDrive, Calendar } from 'lucide-react';
import { openBookingModal } from '../utils/booking';
const icons = {
  db: <Database size={32} className="text-blue-400" />,
  infra: <Server size={32} className="text-blue-400" />,
  storage: <HardDrive size={32} className="text-blue-400" />
};

export const ServiceCard = ({ id, title, items, focus }) => (
  
  
  <div className="bg-[#112240] p-8 rounded-2xl border border-slate-800 hover:border-blue-500/50 transition-all flex flex-col h-full">
    <div className="mb-6">{icons[id]}</div>
    <h3 className="text-xl font-bold text-white mb-4">{title}</h3>
    
    <ul className="space-y-3 mb-8 flex-grow">
      {items.map((item, i) => (
        <li key={i} className="text-sm text-slate-400 flex items-start gap-2 italic">
          <span className="text-blue-500 mt-1">▹</span> {item}
        </li>
      ))}
    </ul>
    
    <div className="pt-4 border-t border-slate-800 mb-6">
      <span className="text-[10px] uppercase tracking-widest text-slate-500 font-bold">Key Focus</span>
      <p className="text-xs text-blue-400 mt-1 font-medium leading-relaxed">{focus}</p>
    </div>

    {/* New Booking Button */}
    <button 
      onClick={() => openBookingModal()}
      className="w-full py-3 px-4 bg-transparent border border-blue-500/50 text-blue-400 rounded-lg text-sm font-bold flex items-center justify-center gap-2 hover:bg-blue-500 hover:text-white transition-all duration-300"
    >
      <Calendar size={16} /> Book a Session
    </button>
  </div>
);